import { BlockRenderer } from '@/components/BlockRenderer';
import { SiloSidebar } from '@/components/molecules';
import { FeaturedPlanIdsContext } from '@/contexts';
import type { AppData } from '@/types/app';

const EDITORIAL_BLOCK_NAME = 'humanoid-blocks-core/editorial-content';

interface BlankPageProps {
  data: AppData;
}

export function BlankPage({ data }: BlankPageProps) {
  const { silo, blocks } = data;
  const featuredPlanIds = data.featuredPlanIds ?? [];
  const editorialIndex = (blocks ?? []).findIndex(
    (b) => b.name === EDITORIAL_BLOCK_NAME,
  );

  if (silo && editorialIndex !== -1) {
    const before = blocks.slice(0, editorialIndex);
    const editorial = blocks[editorialIndex]!;
    const after = blocks.slice(editorialIndex + 1);

    return (
      <FeaturedPlanIdsContext value={featuredPlanIds}>
        {before.length > 0 && <BlockRenderer blocks={before} />}
        <div className="with-silo-sidebar">
          <BlockRenderer blocks={[editorial]} />
          <SiloSidebar silo={silo} />
        </div>
        {after.length > 0 && <BlockRenderer blocks={after} />}
      </FeaturedPlanIdsContext>
    );
  }

  return (
    <FeaturedPlanIdsContext value={featuredPlanIds}>
      <BlockRenderer blocks={blocks} />
    </FeaturedPlanIdsContext>
  );
}
